// 2026 design: mark the header link for the current page with aria-current,
// which .faso-nav-link / .faso-nav-mobile-link style with the Flame marker.
// Done here rather than in the view so the navigation partial carries no new
// Ruby. Exact path match only.
function markActiveNavLinks() {
  document.querySelectorAll('.faso-nav-link[href], .faso-nav-mobile-link[href]').forEach(function (link) {
    if (link.pathname === window.location.pathname) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });
}

document.addEventListener('turbolinks:load', markActiveNavLinks);
